import React from "react";
import { useRecover } from "../hooks/useRecover";
import { Box, FormControl, FormLabel, Input, FormErrorMessage, Button, useColorModeValue, Text, Icon, InputGroup, InputRightElement } from "@chakra-ui/react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";

type PasswordFormProps = Pick<useRecover.type, "state" | "changeInput" | "displayInputError" | "savePass" | "backward">

export const PasswordForm: React.FC<PasswordFormProps> = ({ state, changeInput, displayInputError, savePass, backward }) => {

    const [show, setShow] = React.useState(false);
    const handleClick = () => setShow(!show);


    const textColor = useColorModeValue("navy.700", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");
    const textColorSecondary = "gray.400";

    const { loading } = state;

    return (
        <Box mt="24px">
            <FormControl isInvalid={displayInputError("password").error}>
                <FormLabel
                    display="flex"
                    ms="4px"
                    mt="24px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                >
                    Senha<Text color={brandStars}>*</Text>
                </FormLabel>
                <InputGroup size="md">
                    <Input
                        isRequired={true}
                        fontSize="sm"
                        placeholder="Minimo de 8 caracteres"
                        size="lg"
                        type={show ? "text" : "password"}
                        variant="auth"
                        onBlur={(e) => changeInput({ type: "password", payload: e.target.value })}
                    />
                    <InputRightElement display="flex" alignItems="center" mt="4px">
                        <Icon
                            color={textColorSecondary}
                            _hover={{ cursor: "pointer" }}
                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                            onClick={handleClick}
                        />
                    </InputRightElement>
                </InputGroup>

                {displayInputError("password").error && (
                    <FormErrorMessage>{displayInputError("password").errorMessage}</FormErrorMessage>
                )}
            </FormControl>

            <FormControl isInvalid={displayInputError("passwordConfirm").error}>
                <FormLabel
                    display="flex"
                    ms="4px"
                    mt="24px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                >
                    Repita a Senha<Text color={brandStars}>*</Text>
                </FormLabel>
                <InputGroup size="md">
                    <Input
                        isRequired={true}
                        fontSize="sm"
                        placeholder="Insira a senha novamente"
                        size="lg"
                        type={show ? "text" : "password"}
                        variant="auth"
                        onBlur={(e) => changeInput({ type: "passwordConfirm", payload: e.target.value })}
                    />
                    <InputRightElement display="flex" alignItems="center" mt="4px">
                        <Icon
                            color={textColorSecondary}
                            _hover={{ cursor: "pointer" }}
                            as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                            onClick={handleClick}
                        />
                    </InputRightElement>
                </InputGroup>

                {displayInputError("passwordConfirm").error && (
                    <FormErrorMessage>{displayInputError("passwordConfirm").errorMessage}</FormErrorMessage>
                )}
            </FormControl>

            <Button
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mt="24px"
                isLoading={loading}
                disabled={displayInputError("passwordConfirm").error}
                onClick={savePass}
            >
                SEGUIR
            </Button>

            <Button
                fontSize="sm"
                variant="outline"
                fontWeight="500"
                w="100%"
                h="50"
                mt="24px"
                isLoading={loading}
                onClick={backward}
            >
                Voltar
            </Button>
        </Box>
    );
}